var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFunctionalityCloseSmall = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#242E30",
  d: "M14.834 4.006 10 8.84 5.166 4.006l-1.16 1.16L8.841 10l-4.835 4.834 1.16 1.16L10 11.158l4.834 4.834 1.16-1.159L11.159 10l4.835-4.835z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFunctionalityCloseSmall);
export default ForwardRef;